import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import Radio from '@mui/material/Radio';

import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Avatar from '@mui/material/Avatar';


import {formatNumber} from "../helper/utils";


const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function ModelDesignCard(props) {
	const [expanded, setExpanded] = React.useState(false);
	const { t, i18n } = useTranslation("",{lng: props.language});

  	const handleExpandClick = () => {
    	setExpanded(!expanded);
  	};

  	return (
		<Card sx={{ minWidth: 160 }}>
	    	<CardHeader	title={props.item.label}
	        			subheader={props.item.slogan}
	        			sx={{minHeight: "75px"}}
	      	/>	    
	      	{props.item.image ? ( 
				<picture>
					{props.item.image.map((image)  => (			
				  		<center>
						<Avatar sx={{width: "92px", height: "92px", border: "1px solid #000"}}  src={image.src} />
						</center>

					))}
				</picture>	
				) : (<></>)
			}
			<CardContent>
		  		<Stack  direction="row" justifyContent="space-between" alignItems="center">
	        		<Typography gutterBottom variant="body2" component="div">
	            		{props.item.included == "true" ? (
							<></>
						) : (
							<Checkbox 	data-type="carRoofs" 
								checked={props.checked}
								onClick={e => props.changeItem(e, props.uuid, props.currentArtnr)} />
						)}
	          		</Typography>
	          		<Typography gutterBottom variant="h6" component="div">
	          			{formatNumber("de_DE", props.item.price)}
	          		</Typography>
	        	</Stack>	      	
	      	</CardContent>
	      	
	      	

    	</Card>
  );
}